var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinDrop = function SvgPinDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 16.575q2.39-2.052 3.595-3.951T16.8 9.093q0-2.148-1.338-3.52Q14.126 4.2 12 4.2T8.537 5.576 7.2 9.081q0 1.62 1.205 3.505Q9.609 14.474 12 16.575m0 1.65q-3.071-2.438-4.585-4.726Q5.9 11.212 5.9 9.083q0-2.71 1.704-4.446Q9.31 2.9 12.003 2.9t4.395 1.737T18.1 9.083q0 2.13-1.515 4.412T12 18.225m.005-7.617q.668 0 1.135-.473.468-.472.468-1.14t-.473-1.135a1.56 1.56 0 0 0-1.14-.468q-.668 0-1.135.473a1.56 1.56 0 0 0-.468 1.14q0 .668.473 1.135.472.468 1.14.468M5.9 21.1v-1.3h12.2v1.3z"
  })));
};
export default SvgPinDrop;